export default __webpack_public_path__ + "static/media/U_wdt_c_cap_1.d5d8f926.mp3";